import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { AxiosResponse } from 'axios'
import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'GlobalSearchService'
const host = servicesConfig.GlobalSearch
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

const responseBody = (res: AxiosResponse) => res.data

export interface IGlobalSearchResponse {
  companyId: string,
  locationId: string,
  filterBy: [],
}

const GlobalSearchService = {
  searchDynamic: (query: string, modules: string[], companyId: string, locationId: string,  page: number = 1, pageLimit: number = 20) =>
    request().post(
      `/dynamic`, {
        q: query,
        modules,
        companyId,
        locationId,
        page,
        limit: pageLimit
      }
    ).then(responseBody),

  getAllActiveModules: (locationId: string) =>
      request().get(
        `/modules?locationId=${locationId}`
      ).then(responseBody),
}

export default GlobalSearchService
